import React from 'react';
import { CFormFeedback, CFormLabel, CPopover } from '@coreui/react-pro';
import CIcon from '@coreui/icons-react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import { cloneDeep, convertTimeEST } from '../../../utils';
import { DEFAULT_DATE_TIME_INPUT_FORMAT, DEFAULT_FN } from '../../../constants';

const SimpleInputDateTimeGroup = (props) => {
     const {
          id,
          label,
          placeholder,
          isRequired,
          isResetValue,
          classNameInput,
          value,
          error,
          relationField,
          limitFrom,
          disabled,
          isValidate,
          tooltip,
          handleChange,
          setFieldValue,
     } = props;

     const limitDate = () => {
          if (limitFrom === false) {
               return convertTimeEST(new Date(0));
          }

          if (limitFrom) {
               const newLimit = cloneDeep(limitFrom);
               newLimit.setDate(newLimit.getDate() - 1);
               return newLimit;
          }

          const currentDate = convertTimeEST();
          currentDate.setDate(currentDate.getDate() - 1);
          return currentDate;
     };

     const filterPassedTime = (time) => {
          if (limitFrom === false) {
               return true;
          }

          if (limitFrom) {
               const selectedDate = new Date(time);
               return limitFrom.getTime() <= selectedDate.getTime();
          }

          const currentDate = convertTimeEST();
          const selectedDate = new Date(time);
          return currentDate.getTime() <= selectedDate.getTime();
     };

     const handleChangeSelectDate = (date) => {
          let selectedDate = date || convertTimeEST();

          if (limitFrom !== false) {
               let limitDate = convertTimeEST();

               if (limitFrom) {
                    limitDate = cloneDeep(limitFrom);
               }

               if (limitDate.getTime() > selectedDate.getTime()) {
                    selectedDate = limitDate;
               }
          }

          if (isResetValue && date == null) {
               setFieldValue(id, null);
               handleChange(null);

               if (relationField) {
                    setFieldValue(relationField, null);
               }
          } else {
               setFieldValue(id, selectedDate);
               handleChange(selectedDate);

               if (relationField) {
                    setFieldValue(relationField, selectedDate);
               }
          }
     };

     return (
          <div className="form-group">
               {label && (
                    <CFormLabel htmlFor={id}>
                         {label}
                         {tooltip && (
                              <CPopover content={tooltip} placement="top" trigger="hover">
                                   <CIcon icon="icon-info-cilcle" />
                              </CPopover>
                         )}
                         {isRequired && <span className="text-danger">*</span>}
                    </CFormLabel>
               )}
               <div className={`${(isRequired || isValidate) && !!error ? 'is-invalid-custom is-invalid' : ''}`}>
                    <DatePicker
                         {...props}
                         id={id}
                         placeholderText={placeholder}
                         selected={value}
                         timeInputLabel="Time:"
                         className={classNames('form-control', {
                              [classNameInput]: classNameInput,
                         })}
                         startDate={convertTimeEST()}
                         excludeDateIntervals={[{ start: convertTimeEST(new Date(0)), end: limitDate() }]}
                         filterTime={filterPassedTime}
                         disabled={disabled}
                         autoComplete="off"
                         onChange={handleChangeSelectDate}
                    />
               </div>

               {(isRequired || isValidate) && <CFormFeedback invalid>{error}</CFormFeedback>}
          </div>
     );
};

SimpleInputDateTimeGroup.propTypes = {
     id: PropTypes.string,
     label: PropTypes.string,
     placeholder: PropTypes.string,
     isRequired: PropTypes.bool,
     isResetValue: PropTypes.bool,
     value: PropTypes.any,
     error: PropTypes.string,
     relationField: PropTypes.string,
     limitFrom: PropTypes.any,
     disabled: PropTypes.bool,
     tooltip: PropTypes.string,
     showTimeSelect: PropTypes.bool,
     dateFormat: PropTypes.string,
     setFieldValue: PropTypes.func,
     handleChange: PropTypes.func,
};

SimpleInputDateTimeGroup.defaultProps = {
     value: convertTimeEST(),
     showTimeSelect: true,
     isResetValue: false,
     dateFormat: DEFAULT_DATE_TIME_INPUT_FORMAT,
     setFieldValue: DEFAULT_FN,
     handleChange: DEFAULT_FN,
};

export default SimpleInputDateTimeGroup;
